<template>
  <div id="app">
    <head-component></head-component>
    <keep-alive exclude='newsNotice'>
      <router-view/>
    </keep-alive>
    <!-- <div class="w-code" ref="wxCode" @mouseover="mouseOver" @mouseout="mouseOut">
      <img src="./assets/images/wx_tb.png" alt="">
    </div> -->
    <div class="wx-qrcode" v-if="show">
      <div class="wx-qrcode-content">
        <span>扫码立即体验</span>
        <img src="./assets/images/wx_qrcode.jpg" alt="">
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
  import headComponent from './components/headComponent.vue';
  import footerComponent from './components/footerComponent';
export default {
  name: 'App',
  data(){
    return{
      show:false,
    }
  },
  components: {
    headComponent,footerComponent
  },
  methods:{
    mouseOver(){//鼠标经过
    this.show = true
    this.$refs.wxCode.style.backgroundColor = '#25B1F7'
    },
    mouseOut(){//鼠标离开
    this.show = false
    this.$refs.wxCode.style.backgroundColor = '#000000'

    }
  },
  created(){
    // console.log(this.$route)
  },
  watch:{
    // '$route.path':function(){
    //   console.log(this.$route.path)
    // }
  }
}
</script>

<style scoped lang='less'>
#app {
  width: 100%;
  height: auto;

}
.w-code{
  position: fixed;
  right: 0;
  top: 456px;
  width: 40px;
  height: 50px;
  
  background-color: #000000;
  border-radius:6px 0px 0px 6px;
  opacity: 0.6;
  padding-top: 15px;
  box-sizing: border-box;
  img{
    margin-left:10px;
  }
}
.wx-qrcode{
  position: fixed;
  right: 60px;
  top: 456px;
  width: 150px;
  height: 170px;
  border: 1px solid #e5e5e5;
  .wx-qrcode-content{
    text-align: center;
    span{
      font-size: 14px;
      color: #666;
    }
    img{
      margin-top: 5px
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue